import { Auth } from './pages/Auth/page/Auth';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';
import { ProtectedRouter } from './utils/services/ProtectedRouter';
import { ServerError } from './pages/Trader/Errors/ServerError';
import { ForbiddenError } from './pages/Trader/Errors/ForbiddenError';
import { NotFoundError } from './pages/Trader/Errors/NotFoundError';
import {
  AUTH,
  FORBIDDEN_ERROR,
  SERVER_ERROR,
  MERCHANT_APPLICATIONS,
  MERCHANT_SETTLEMENTS,
  MERCHANT_DISPUTES,
  MERCHANT_OVERVIEW,
} from './utils/constants/routes';
import { useRecoilState } from 'recoil';
import { defaultIsMobile } from './utils/states/isMobile.state';
import { MerchantApplicationsPage } from './features/merchant-cabinet/pages/MerchantApplicationsPage';
import { MerchantDisputesPage } from './features/merchant-cabinet/pages/MerchantDisputesPage';
import { MerchantOverviewPage } from './features/merchant-cabinet/pages/MerchantOverviewPage';
import { MerchantSettlementsPage } from './features/merchant-cabinet/pages/MerchantSettlementsPage';
export const App = () => {
  const [version, setVersion] = useRecoilState(defaultIsMobile);
  useEffect(() => {
    const handleResize = () => {
      setVersion({ isMobile: window.innerWidth <= 1024 });
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Router>
      <div className='App' style={{ height: '100%' }}>
        <Routes>
          <Route path={'*'} element={<NotFoundError />} />
          <Route path={SERVER_ERROR} element={<ServerError />} />
          <Route path={FORBIDDEN_ERROR} element={<ForbiddenError />} />
          <Route path={AUTH} element={<Auth />} />
          <Route path={''} element={<ProtectedRouter />}>
            <Route path="/merchant" element={<Navigate to={MERCHANT_OVERVIEW} replace />} />
            <Route path={MERCHANT_OVERVIEW} element={<MerchantOverviewPage />} />
            <Route path={MERCHANT_APPLICATIONS} element={<MerchantApplicationsPage />} />
            <Route path={MERCHANT_SETTLEMENTS} element={<MerchantSettlementsPage />} />
            <Route path={MERCHANT_DISPUTES} element={<MerchantDisputesPage />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
};
